import Template from './FileUploadThumbnail.njk';
import Marionette from "backbone.marionette";
import { Config } from "../../application/Config";
import "./FileUploadThumbnail.less";

export const FileUploadThumbnail = Marionette.View.extend({
  template: Template,
    className: "FileUploadThumbnail",
    templateContext() {
        var now = new Date();
        var hasImage = this.model.get("image");
        var imageUrl = (Config.baseUrl.configuration ? Config.baseUrl.configuration + "/" + this.model.get("image") : this.model.get("image")) + "?timestamp=" + now.getTime();
        return {
            imageUrl: hasImage ? imageUrl : null
        }
    }
});


// WEBPACK FOOTER //
// ./src/js/view/components/FileUploadThumbnail.js